import { c as _c } from "react/compiler-runtime";
import type { FC, HTMLProps } from "react";
import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { clsx } from "clsx";
import { Icon } from "../../widgets";
import { Input } from "../Input";
import styles from "./TextInput.module.scss";
import type { TextInputProps } from "./TextInput.d";
export const TextInput: FC<Omit<HTMLProps<HTMLInputElement>, keyof TextInputProps> & TextInputProps> = t0 => {
  const $ = _c(11);
  let props;
  let t1;
  if ($[0] !== t0) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        icon,
        containerClassName,
        ...t2
      } = t0;
      props = t2;
      if (icon === "search") {
        let t3;
        if ($[3] !== containerClassName) {
          t3 = clsx(styles.container, containerClassName);
          $[3] = containerClassName;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        let t4;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <Icon icon={faMagnifyingGlass} className={styles.icon} />;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = <Input {...props} className={clsx(styles.input, props.className)} />;
        let t6;
        if ($[6] !== t3 || $[7] !== t5) {
          t6 = <div className={t3}>{t4}{t5}</div>;
          $[6] = t3;
          $[7] = t5;
          $[8] = t6;
        } else {
          t6 = $[8];
        }
        t1 = t6;
        break bb0;
      }
    }
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[9] !== props) {
    t2 = <Input {...props} />;
    $[9] = props;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default TextInput;